var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c("v-col", [
            _c("h1", [_vm._v("Provision Invoice Batch Monitoring")]),
            _c("p", { staticClass: "subtitle-1" }, [
              _vm._v("Monitor and explore provision invoice batch processing")
            ])
          ])
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _vm._v(" Recent Batches "),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", loading: _vm.loading },
                          on: { click: _vm.refreshBatches }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-refresh")
                          ]),
                          _vm._v(" Refresh ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c("provision-batch-table", {
                        attrs: { batches: _vm.recentBatches },
                        on: { "select-batch": _vm.selectBatch }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.selectedBatch
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("provision-batch-details", {
                    attrs: {
                      batch: _vm.selectedBatch,
                      summary: _vm.selectedBatchSummary
                    },
                    on: { close: _vm.closeDetails }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          attrs: { color: "error", timeout: "5000" },
          model: {
            value: _vm.errorSnackbar,
            callback: function($$v) {
              _vm.errorSnackbar = $$v
            },
            expression: "errorSnackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.error) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }